import React, { useEffect, useState } from 'react'

export default function useSaveData(storageLocation, fallbackState) {

    const [value, setValue] = useState(sessionStorage.getItem(storageLocation) ?? fallbackState);

    const saveStateToSessionStorage = (info) => {
        sessionStorage.setItem(storageLocation, JSON.stringify(info))
        setValue(JSON.stringify(info))
        //console.log(value); 
    }

    useEffect(() => {
        
    },[storageLocation])

  return [ value , saveStateToSessionStorage ] ;
}